export abstract class AbstractApiRequestInterceptor<RequestOptions = unknown> {
    public abstract intercept(requestOption: RequestOptions): Promise<RequestOptions>;
}
